var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#323338;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7568",
    "data-name": "Path 7568",
    className: "cls-1",
    d: "M13,11H10a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h3a1,1,0,0,0,1-1V12A1,1,0,0,0,13,11ZM13,1V2H5V1A1,1,0,0,0,3,1V2H2A2,2,0,0,0,0,4H0V18a2,2,0,0,0,2,2H16a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2H15V1a1,1,0,0,0-2,0Zm2,17H3a1,1,0,0,1-1-1V7H16V17A1,1,0,0,1,15,18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.b7e345e0852c3a5994bc72bf4711e6fe.svg";
export { ForwardRef as ReactComponent };